import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthGuard } from "../App";
import { Oval } from "react-loader-spinner";
import { EmailGuard } from "../App";
import { StandardURL } from "../App";


const InputField = ({ label, value, onChange, type = "text", ...props }) => (
  <div className="mb-4">
    <label className="block text-gray-700 mb-2">{label}</label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      className="w-full px-3 py-2 border rounded"
      {...props}
    />
  </div>
);

const SMSSender = () => {
  const [smsCategory, setSMSCategory] = useState("tenants");
  const [message, setMessage] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const maxMessageLength = 144;

  const validateFields = () => {
    if (!message) {
      toast.error("Message is required");
      return false;
    }

    if (smsCategory === "tenantsByProperty" && !propertyId) {
      toast.error("Property ID is required");
      return false;
    }

    return true;
  };

  const handleSendSMS = async () => {
    if (!validateFields()) return;

    setLoading(true);

    let endpoint = "";
    let data = {
      message,
    };

    switch (smsCategory) {
      case "tenants":
        endpoint = `${StandardURL}/iNyumba/admin/sms/tenants`;
        break;
      case "landlords":
        endpoint = `${StandardURL}/iNyumba/admin/sms/landlords`;
        break;
      case "all":
        endpoint = `${StandardURL}/iNyumba/admin/sms/all`;
        break;
      case "tenantsByProperty":
        endpoint = `${StandardURL}/iNyumba/admin/sms/tenants/${propertyId}`;
        break;
      default:
        break;
    }

    try {
      await axios.post(endpoint, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      toast.success("Email sent successfully!");
      // Clear all states after sending
      setMessage("");
      setPropertyId("");
    } catch (error) {
      const errorMessage =
        error.response?.data?.response || "An error occurred.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-2xl rounded-2xl bg-white p-8 shadow-xl">
            <h1 className="mb-8 text-3xl font-bold tracking-tight text-gray-900">
              Send SMS
            </h1>

            {/* SMS Category Selector */}
            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-gray-700">SMS Category</label>
              <select
                value={smsCategory}
                onChange={(e) => setSMSCategory(e.target.value)}
                className="w-full cursor-pointer rounded-lg border border-gray-300 px-4 py-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                <option value="tenants">All Tenants</option>
                <option value="landlords">All Landlords</option>
                <option value="all">Everyone</option>
                <option value="tenantsByProperty">Tenants by Property ID</option>
              </select>
            </div>

            {/* Message Area */}
            <div className="mb-4">
              <label className="mb-2 block text-sm font-medium text-gray-700">Message</label>
              <textarea
                value={message}
                onChange={(e) => {
                  const text = e.target.value;
                  if (text.length <= maxMessageLength) {
                    setMessage(text);
                  }
                }}
                className="w-full h-40 resize-none rounded-lg border border-gray-300 px-4 py-3 text-gray-700 placeholder-gray-400 transition-colors duration-200 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
              <p className={`mt-2 text-sm text-right ${message.length >= maxMessageLength * 0.9 ? 'text-red-500' : 'text-gray-500'}`}>
                {message.length}/{maxMessageLength} characters
              </p>
            </div>

            {/* Conditional Input Field */}
            {smsCategory === "tenantsByProperty" && (
              <InputField
                label="Property ID"
                value={propertyId}
                onChange={(e) => setPropertyId(e.target.value)}
              />
            )}

            {/* Send Button with Loading State */}
            <button
              onClick={handleSendSMS}
              disabled={loading}
              className={`flex w-full items-center justify-center rounded-full bg-blue-600 px-6 py-3 font-semibold text-white shadow-md transition-all duration-200 ${
                loading ? "cursor-not-allowed opacity-70" : "hover:scale-105 hover:bg-blue-700"
              }`}
            >
              {loading ? (
                <Oval
                  height={20}
                  width={20}
                  color="#fff"
                  secondaryColor="#EBF4FF"
                  ariaLabel="loading"
                  strokeWidth={4}
                />
              ) : (
                "Send SMS"
              )}
            </button>
          </div>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};

export default SMSSender;
